import { ReactNode, Component } from 'react';
import { FpjsProvider, CacheLocation } from '@fingerprintjs/fingerprintjs-pro-react';

interface FingerprintProviderProps {
  children: ReactNode;
}

class FingerprintErrorBoundary extends Component<
  { children: ReactNode },
  { hasError: boolean }
> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    console.warn('[Fingerprint] Script load error caught:', error.message);
  }

  render() {
    if (this.state.hasError) {
      return <>{this.props.children}</>;
    }
    return this.props.children;
  }
}

export function FingerprintProvider({ children }: FingerprintProviderProps) {
  const apiKey = import.meta.env.VITE_FINGERPRINT_PUBLIC_API_KEY;

  if (!apiKey) {
    console.warn('[Fingerprint] No API key found - fingerprinting disabled');
    return <>{children}</>;
  }

  return (
    <FingerprintErrorBoundary>
      <FpjsProvider
        loadOptions={{
          apiKey,
          region: 'us',
        }}
        cacheLocation={CacheLocation.SessionStorage}
        cacheTimeInSeconds={3600}
      >
        {children}
      </FpjsProvider>
    </FingerprintErrorBoundary>
  );
}
